/**
 * Triggers a client-side download of in-memory text as a file.
 *
 * Used for exports built entirely in the browser (CSV report cuts), where
 * there is no server endpoint to link to. The object URL is revoked
 * immediately after the click — the browser has already taken its own
 * reference by then, so releasing it does not cancel the download.
 *
 * @param filename - Suggested filename, including extension.
 * @param contents - File body.
 * @param mimeType - Defaults to UTF-8 CSV.
 * @example
 * downloadTextFile('coverage.csv', csv);
 */
export function downloadTextFile(
  filename: string,
  contents: string,
  mimeType = 'text/csv;charset=utf-8;'
): void {
  // A BOM keeps Excel from mangling non-ASCII (Arabic zone names) on open.
  const blob = new Blob([`\uFEFF${contents}`], { type: mimeType });
  const url = URL.createObjectURL(blob);

  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  anchor.style.display = 'none';

  document.body.append(anchor);
  anchor.click();
  anchor.remove();

  URL.revokeObjectURL(url);
}
